import { Box, Typography, useTheme } from '@mui/material'

export const NoLabResults = () => {
    const theme = useTheme()

    return (
        <Box
            sx={{
                mt: 4,
                p: 2,
                background: theme.palette.background.paper,
                borderRadius: 'default'
            }}
        >
            <Typography sx={{ fontStyle: 'italic' }}>
                No lab results available at this time.
            </Typography>
        </Box>
    )
}
